import React from "react";

function LoginForm({ onSubmit, register, errors }) {
    return (
        <div>
            <div className="card-body">
                <p className="login-box-msg">Welcome back you've been missed!</p>
                <form onSubmit={onSubmit}>
                <div className="input-group mb-3">
                    <input
                    type="text"
                    className={`form-control ${errors.identifier?.message ? 'is-invalid': ''}`}
                    placeholder="Mobile Number/ Email"
                    name="identifier"
                    {...register("identifier", { 
                        required: "Mobile number/Email is required",
                        pattern: { 
                            value: /^([0-9]{10}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/, 
                            message: "Enter a valid 10-digit mobile number or email address" 
                        }
                    })}
                    />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fa fa-user" />
                        </div>
                    </div>
                    {errors.identifier && <span className="invalid-feedback">{errors.identifier.message}</span>}
                </div>
                <div className="input-group mb-3">
                    <input
                    type="password"
                    className={`form-control ${errors.password?.message ? 'is-invalid': ''}`}
                    placeholder="Password"
                    name="password"
                    {...register("password", { 
                        required: "Password is required",
                        minLength: {
                            value: 6, // Minimum length of 6 characters
                            message: "Password must be at least 6 characters long",
                        },
                     })}
                    />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fas fa-lock" />
                        </div>
                    </div>
                    {errors.password && <span className="invalid-feedback">{errors.password.message}</span>}
                </div>
                <div className="row">
                    {/* /.col */}
                    <div className="col-12">
                    <button type="submit" className="btn btn-primary btn-block">
                        Sign In
                    </button>
                    </div>
                    {/* /.col */}
                </div>
                </form>
                <p className="mt-3 mb-1">
                <a href="/forgot-password">Forgot your password?</a>
                </p>
                <p className="mb-1">
                <a href="/register" className="text-center">
                    Dont have an account? Sign Up
                </a>
                </p>
            </div>
        </div>
    );
}

export default LoginForm;